import { createRoot } from 'react-dom/client';
import { getCsvAttribute } from '@repo/widget-utils/attributes/attribute-helper';
import BilberryCustomElement from 'src/widgets/BilberryCustomElement';
import { WidgetWrapper } from 'src/widgets/WidgetWrapper';
import MemberCardPurchase from './MemberCardPurchase';

class BilberryMemberCardWidget extends BilberryCustomElement {
    protected renderWidget(): void {
        const preselectedProductId =
            this.getAttribute('preselected-member-card-product-id') ?? undefined;
        // Optional whitelist; empty/absent shows every sellable product.
        const allowedProductIds = getCsvAttribute(this, 'member-card-product-ids');

        createRoot(this._mountPoint).render(
            <WidgetWrapper
                mountPoint={this._mountPoint}
                popoverMountPoint={this._popoverMountPoint}
                shadowRoot={this._shadowRoot}
            >
                <MemberCardPurchase
                    preselectedProductId={preselectedProductId}
                    allowedProductIds={allowedProductIds}
                />
            </WidgetWrapper>,
        );
    }
}

export default function defineCustomElement(): void {
    customElements.define('bilberry-member-card-widget', BilberryMemberCardWidget);
}
